module.exports = __webpack_public_path__ + "img/162.laptop.e896d3f9.svg";